import React from 'react';
// import { formatDuration } from '../utils/testUtils';

function cleanStackTrace(stackTrace) {
  // Remove lines that are just attachment tags, usage, or trace file paths
  if (!stackTrace) return '';
  return stackTrace
    .split('\n')
    .filter(line => {
      const trimmed = line.trim();
      if (trimmed.startsWith('<![CDATA[  [chromium]')) return false;
      if (trimmed.startsWith('attachment #')) return false;
      if (trimmed.startsWith('Usage:')) return false;
      if (trimmed.match(/^out\/.+\.zip$/)) return false;
      if (trimmed === '────────────────────────────────────────────────────────────────────────────────────────────────') return false;
      return true;
    })
    .join('\n')
    .replace(/\n{3,}/g, '\n\n') // Collapse extra blank lines
    .trim();
}

function TestCaseDrawer({ open, onClose, testcase }) {
  if (!open || !testcase) return null;
  const errorMsg = testcase.failure?.message || testcase.error?.message || testcase.failure || testcase.error || 'No error message.';
  const stackTrace = testcase.failure?.['$t'] || testcase.error?.['$t'] || testcase['system-err'] || testcase['system-out'] || '';

  const errorTrace = testcase.failure?._ || testcase.error?._ || 'Unknown';
  const cleanedStack = cleanStackTrace(stackTrace);
  return (
    <div style={{ position: 'fixed', top: 0, right: 0, width: 440, height: '100vh', background: 'var(--color-card)', boxShadow: '-4px 0 24px #0002', zIndex: 2000, display: 'flex', flexDirection: 'column', borderLeft: '1px solid var(--color-card-border)', transition: 'transform 0.3s', transform: open ? 'translateX(0)' : 'translateX(100%)' }}>
      <button onClick={onClose} style={{ alignSelf: 'flex-end', margin: 18, fontSize: 22, background: 'none', border: 'none', color: '#888', cursor: 'pointer' }}>&times;</button>
      <div style={{ padding: '0 2.2rem 2.5rem 2.2rem', overflowY: 'auto' }}>
        <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 18 }}>Test Failure Details</div>
        <div style={{ fontWeight: 600, marginBottom: 8, color: '#ef4444', fontSize: 17 }}>Error Message</div>
        <div style={{ marginBottom: 18, whiteSpace: 'pre-wrap', color: '#ef4444', fontWeight: 600, fontSize: 16, background: '#fee2e2', borderRadius: 8, padding: '10px 14px' }}>{errorMsg}</div>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Test Name</div>
        <div style={{ marginBottom: 18, color: '#222', fontWeight: 500 }}>{testcase.name}</div>
        {testcase.failure?.message && (
          <div style={{ fontWeight: 600, marginBottom: 8 }}>Failure Message</div>
        )}
        {testcase.failure?.message && (
          <pre style={{ background: '#f3f4f6', color: '#ef4444', borderRadius: 8, padding: 12, fontSize: 14, overflowX: 'auto', marginBottom: 12 }}>{errorTrace}</pre>
        )}
        {cleanedStack && <>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>Stack Trace</div>
          <pre style={{ background: '#f3f4f6', color: '#222', borderRadius: 8, padding: 12, fontSize: 14, overflowX: 'auto', marginBottom: 0 }}>{cleanedStack}</pre>
        </>}
      </div>
    </div>
  );
}

export default TestCaseDrawer; 